import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { VehicleCategoryTypeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-type.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleBodyTypeEnum } from '../../../tenant/vehicles/enums/vehicle-body-type.enum';
import { VehicleDriveTrainTypeEnum } from '../../../tenant/vehicles/enums/vehicle-drive-train-type.enum';
import { VehicleFuelTypeEnum } from '../../../tenant/vehicles/enums/vehicle-fuel-type.enum';
import { VehiclePowerPlantTypeEnum } from '../../../tenant/vehicles/enums/vehicle-power-plant-type.enum';
import { VehicleTransmissionTypeEnum } from '../../../tenant/vehicles/enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../../../tenant/vehicles/enums/vehicle-type.enum';
import { AssetTypeEnum } from '../../assets/enums/asset-type.enum';

/**
 * Asset cache filters
 */
export class AssetSearchCacheFilters extends ApiRequestFilters {
  /**
   * Area UUID
   */
  areaUuid?: string;

  /**
   * Types
   */
  types?: AssetTypeEnum[];

	/**
	 * Vehicle group UUID filters
	 */
	vehicleGroupUuids?: string[];

	/**
	 * Duration unit
	 */
	durationUnit?: DurationUnitEnum;

  /**
   * Available date from
   */
  @TransformDate()
  dateFrom?: Date;

  /**
   * Available date to
   */
  @TransformDate()
  dateTo?: Date;

  /**
   * Flag to include unavailable records in results
   */
  includeUnavailable?: boolean = true;

  /**
   * Minimum total gross
   */
  @TransformFloat()
  totalGrossFrom?: number;

  /**
   * Maximum total gross
   */
  @TransformFloat()
  totalGrossTo?: number;

  /**
   * Feature type
   */
  featureType?: VehicleTypeEnum[];

  /**
   * Feature seats
   */
  featureSeats?: number;

  /**
   * Feature doors
   */
  featureDoors?: number;

  /**
   * Feature category type
   */
  featureCategoryType?: VehicleCategoryTypeEnum[];

  /**
   * Feature body type
   */
  featureBodyType?: VehicleBodyTypeEnum[];

  /**
   * Feature transmission type
   */
  featureTransmissionType?: VehicleTransmissionTypeEnum[];

  /**
   * Feature drive train type
   */
  featureDriveTrainType?: VehicleDriveTrainTypeEnum[];

  /**
   * Feature fuel type
   */
  featureFuelType?: VehicleFuelTypeEnum[];

  /**
   * Feature primary power plant type
   */
  featurePrimaryPowerPlantType?: VehiclePowerPlantTypeEnum[];

  /**
   * Feature secondary power plant type
   */
  featureSecondaryPowerPlantType?: VehiclePowerPlantTypeEnum[];

  /**
   * GPS latitude for location-based filtering
   */
  @TransformFloat()
  gpsLatitude?: number;

  /**
   * GPS longitude for location-based filtering
   */
  @TransformFloat()
  gpsLongitude?: number;

  /**
   * Radius in kilometers for location-based filtering
   */
  @TransformFloat()
  radiusKm?: number;
}
